import type { SchemaOf } from '../../helpers';
import { Joi, makeAllRequired } from '../../helpers';

export interface IConfig {
  adminQueryNames: string[];
  exportedCollections?: string[];
}

export const schemaMap: SchemaOf<IConfig> = {
  adminQueryNames: Joi.array().items(Joi.string().not('')).min(0),
  exportedCollections: Joi.array().items(Joi.string().not('')),
};

export const schemaMapDefault = makeAllRequired<IConfig>(schemaMap, [
  'exportedCollections',
]);

export const defaultConfig: IConfig = {
  adminQueryNames: [],
};
